'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Mixins$FormBuilder = require("./Mixins.bs.js");
var Palette$FormBuilder = require("./Palette.bs.js");

var outputContainer = Curry._1(Css.style, {
      hd: Css.padding2({
            NAME: "rem",
            VAL: 4
          }, {
            NAME: "rem",
            VAL: 5
          }),
      tl: {
        hd: Css.paddingLeft({
              NAME: "rem",
              VAL: 6.5
            }),
        tl: {
          hd: Css.width({
                NAME: "percent",
                VAL: 60
              }),
          tl: {
            hd: Css.height({
                  NAME: "vh",
                  VAL: 100
                }),
            tl: {
              hd: Css.color({
                    NAME: "hex",
                    VAL: "fff"
                  }),
              tl: {
                hd: Css.backgroundColor({
                      NAME: "hex",
                      VAL: Palette$FormBuilder.bgPrimary
                    }),
                tl: {
                  hd: Css.media("(max-width: 780px)", {
                        hd: Css.width({
                              NAME: "percent",
                              VAL: 100
                            }),
                        tl: /* [] */0
                      }),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

var outputFormContainer = Curry._1(Css.style, {
      hd: Css.paddingRight({
            NAME: "rem",
            VAL: 1.5
          }),
      tl: {
        hd: Css.maxHeight({
              NAME: "percent",
              VAL: 100
            }),
        tl: {
          hd: Css.overflow("scroll"),
          tl: {
            hd: Css.height({
                  NAME: "percent",
                  VAL: 100
                }),
            tl: /* [] */0
          }
        }
      }
    });

var inputContainer = Curry._1(Css.merge, {
      hd: Mixins$FormBuilder.flex_col_start_start,
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.flexGrow(0),
              tl: {
                hd: Css.marginTop({
                      NAME: "em",
                      VAL: 2
                    }),
                tl: {
                  hd: Css.selector("&:first-child", {
                        hd: Css.marginTop({
                              NAME: "em",
                              VAL: 0
                            }),
                        tl: /* [] */0
                      }),
                  tl: /* [] */0
                }
              }
            }),
        tl: /* [] */0
      }
    });

function question(placeholderOpt) {
  var placeholder = placeholderOpt !== undefined ? placeholderOpt : false;
  return Curry._1(Css.style, {
              hd: Css.fontSize({
                    NAME: "rem",
                    VAL: 2.6
                  }),
              tl: {
                hd: Css.width({
                      NAME: "percent",
                      VAL: 100
                    }),
                tl: {
                  hd: Css.marginTop({
                        NAME: "em",
                        VAL: 0.5
                      }),
                  tl: {
                    hd: Css.color(placeholder ? ({
                              NAME: "hex",
                              VAL: "888"
                            }) : ({
                              NAME: "hex",
                              VAL: Palette$FormBuilder.textWhite
                            })),
                    tl: /* [] */0
                  }
                }
              }
            });
}

var scaleContainer = Curry._1(Css.merge, {
      hd: Mixins$FormBuilder.flex_start_start,
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.marginTop({
                    NAME: "em",
                    VAL: 1
                  }),
              tl: {
                hd: Css.maxWidth({
                      NAME: "percent",
                      VAL: 100
                    }),
                tl: {
                  hd: Css.flexWrap("wrap"),
                  tl: {
                    hd: Css.overflowY("scroll"),
                    tl: /* [] */0
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

var scaleItem = Curry._1(Css.merge, {
      hd: Mixins$FormBuilder.flex_center_center,
      tl: {
        hd: Curry._1(Css.style, {
              hd: Css.width({
                    NAME: "em",
                    VAL: 2
                  }),
              tl: {
                hd: Css.height({
                      NAME: "em",
                      VAL: 2.5
                    }),
                tl: {
                  hd: Css.backgroundColor({
                        NAME: "hex",
                        VAL: Palette$FormBuilder.bgSecondary
                      }),
                  tl: {
                    hd: Css.flexShrink(0),
                    tl: {
                      hd: Css.color({
                            NAME: "hex",
                            VAL: Palette$FormBuilder.textBlack
                          }),
                      tl: {
                        hd: Css.borderRight(Css.px(1), "solid", Css.lightgray),
                        tl: {
                          hd: Css.marginTop({
                                NAME: "px",
                                VAL: 1
                              }),
                          tl: {
                            hd: Css.selector("&:last-child", {
                                  hd: Css.borderRight(Css.px(1), "none", Css.lightgray),
                                  tl: /* [] */0
                                }),
                            tl: {
                              hd: Css.transition(200, undefined, undefined, "background-color"),
                              tl: {
                                hd: Css.selector("&:hover, &:focus, &:active", {
                                      hd: Css.textDecoration("none"),
                                      tl: {
                                        hd: Css.backgroundColor({
                                              NAME: "hex",
                                              VAL: "eee"
                                            }),
                                        tl: /* [] */0
                                      }
                                    }),
                                tl: {
                                  hd: Css.selector("&.active", {
                                        hd: Css.backgroundColor({
                                              NAME: "hex",
                                              VAL: Palette$FormBuilder.fgTertiary
                                            }),
                                        tl: {
                                          hd: Css.color(Css.whitesmoke),
                                          tl: /* [] */0
                                        }
                                      }),
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

var textInput = Curry._1(Css.style, {
      hd: Css.backgroundColor({
            NAME: "hex",
            VAL: Palette$FormBuilder.bgPrimary_accent
          }),
      tl: {
        hd: Css.fontWeight("medium"),
        tl: {
          hd: Css.fontSize({
                NAME: "rem",
                VAL: 1.8
              }),
          tl: {
            hd: Css.width({
                  NAME: "percent",
                  VAL: 100
                }),
            tl: {
              hd: Css.border(Css.px(1), "none", Css.red),
              tl: {
                hd: Css.padding2(Css.em(0.6), Css.em(1)),
                tl: {
                  hd: Css.borderRadius({
                        NAME: "em",
                        VAL: 0.1
                      }),
                  tl: {
                    hd: Css.marginTop(Css.em(1)),
                    tl: {
                      hd: Css.transition(200, undefined, undefined, "background-color, color"),
                      tl: {
                        hd: Css.selector("&:active, &:focus", {
                              hd: Css.backgroundColor({
                                    NAME: "hex",
                                    VAL: Palette$FormBuilder.bgSecondary
                                  }),
                              tl: {
                                hd: Css.outline(Css.px(1), "none", Css.red),
                                tl: {
                                  hd: Css.color({
                                        NAME: "hex",
                                        VAL: Palette$FormBuilder.textBlack
                                      }),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

exports.outputContainer = outputContainer;
exports.outputFormContainer = outputFormContainer;
exports.inputContainer = inputContainer;
exports.question = question;
exports.scaleContainer = scaleContainer;
exports.scaleItem = scaleItem;
exports.textInput = textInput;
/* outputContainer Not a pure module */
